import { ColumnType } from "antd/es/table";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateMenuData } from "../../store/slices/misc/menuData";
import { useLocation } from "react-router";
import Template1 from "./ReportTemplates/Template1";


const UnAssignedTaskReport = () => {
  const dispatch = useDispatch();
    const location = useLocation();

  const columns: ColumnType<any>[] = [
    {
      title: "Task ID",
      dataIndex: "taskId",
      key: "taskId",
      width: 50,
      fixed: "left",
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Phase",
      dataIndex: "phases",
      key: "phases",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Created On",
      dataIndex: "createdDate",
      key: "createdDate",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
    {
      title: "Deadline",
      dataIndex: "deadLine",
      key: "deadLine",
      width: 100,
      render: (text) => (text === null || text === undefined || text === "" ? "N/A" : text)
    },
  ]

  useEffect(() => {
      dispatch(
        updateMenuData([
          {
            text: "UnAssigned Task Report",
            link: "pms/unassigned-task-report",
          },
        ])
      );
    }, []);

  return (
    <>
     <Template1
      moduleKey={window.location.pathname}
        columns={columns}
        pageTitle="UnAssigned Task Report"
        pageDescription=""
         previousPath={{
          link: "/pms/project/reports",
          state: location.state,
        }}
         filters={{
          defaultFilters: {
            dateRange: {
              title: "Custom Date Range",
            },
          },
        }}
        />
    </>
  );
};

export default UnAssignedTaskReport;
